var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M719.45 25.0996H80.45C80.25 25.0996 80.025 25.0996 79.775 25.0996C49.8 25.0996 25.475 49.1996 25.125 79.0746V720.875C25.475 750.775 49.8 774.9 79.775 774.9C80.025 774.9 80.25 774.9 80.5 774.9H719.375C719.575 774.9 719.825 774.9 720.075 774.9C750.075 774.9 774.45 750.825 774.925 720.925V720.875V79.1246C774.45 49.1996 750.075 25.0996 720.05 25.0996C719.8 25.0996 719.575 25.0996 719.325 25.0996H719.45ZM247.5 664.05H136.15V306.275H247.5V664.05ZM191.85 257.325C156.225 257.325 127.375 228.45 127.375 192.85C127.375 157.25 156.25 128.375 191.85 128.375C227.45 128.375 256.325 157.225 256.325 192.825C256.325 192.85 256.325 192.875 256.325 192.925C256.325 228.5 227.475 257.35 191.9 257.35C191.875 257.35 191.85 257.35 191.825 257.35L191.85 257.325ZM663.9 664.05H552.875V490.075C552.875 448.575 552.025 395.2 495.025 395.2C437.125 395.2 428.3 440.35 428.3 487.025V664.075H317.275V306.3H423.925V355.075H425.375C446.075 320.2 483.525 297.2 526.35 297.2C527.875 297.2 529.375 297.225 530.875 297.275H530.65C643.15 297.275 663.95 371.325 663.95 467.7V664.075L663.9 664.05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo_linkedin.78ff0b453fe4262f91e63e01162fa78c.svg";
export { ForwardRef as ReactComponent };